/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 30/12/2021
 */


// import Pager from "./Pager";
import {FirestorePager} from "@qwoach/firebase-data-manager";

export default class PagerLocal extends FirestorePager {

	dataArray

	constructor(dataArray = []) {
		super();
		this.dataArray = dataArray
	}

	isInitialLoad(){
		return true
	}

	async next(){
		this.hasMore = false;
		if(typeof this.dataArray === "function"){
			return this.dataArray()
		}
		return this.dataArray
	}


}
